<!--Vista que muestra la sección de registro de los usuarios lite-->
<template>
  <v-container fluid class="pa-0">
    <v-row justify="center" class="mt-5 py-5">
      <v-col cols="12">
        <!--<v-row justify="center">
          <v-col cols="12" class="text-center mb-5">
            <h1 class="display-2 font-weight-bold">Únete a WeChamber</h1>
            <h2
              class="headline"
            >Forma parte de uno de los mejores sitios para organizar eventos y gestionar afiliaciones.</h2>
          </v-col>
        </v-row>-->

        <v-row justify="center" class="mb-10 mt-3">
          <v-col cols="11" md="11" lg="7" class="elevation-3 pa-0">
            <v-row justify="center">
              <!-- <v-col cols="3" class="px-7 py-10 form-img d-none d-md-inline">
                <v-row justify="center" align="center" class="fill-height">
                  <v-img src="@/assets/logo-WC.png"></v-img>
                </v-row>
              </v-col>-->
              <v-col col="9" class="py-xl-5 px-xl-10">
                <v-window class="form-container px-10" :touchless="true">
                  <!-- REGISTRO PARA UNA ORGANIZACIÓN -->
                  <v-window-item class="form-container">
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row justify="center">
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <h1 class="display-1 font-weight-bold secondary--text">Crea tu cuenta de WeChamber Lite</h1>
                            </v-col>
                            <!--
                            <v-col cols="12" class="pb-0">
                              <v-row justify="center">
                                <v-col cols="5" sm="3" lg="2" class="pb-0">
                                  <file-pond
                                    name="filepond"
                                    class="filepond"
                                    ref="pondPicture"
                                    label-idle="Agrega tu logotipo."
                                    accepted-file-types="image/png, image/jpeg"
                                    allowImagePreview="true"
                                    allowReplace="true"
                                    maxFiles="1"
                                    stylePanelLayout="compact circle"
                                    styleLoadIndicatorPosition="center bottom"
                                    styleProgressIndicatorPosition="right bottom"
                                    styleButtonProcessItemPosition="right bottom"
                                    styleButtonRemoveItemPosition="left bottom"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>-->
                            <v-col cols="12" class="pb-0">
                              <v-row justify="center">
                                <v-avatar :size="($vuetify.breakpoint.xsOnly)?200:($vuetify.breakpoint.smOnly)?200:140">
                              <!--<img :src="user.profilePicture" alt="avatar" />-->
                              <v-img :src="profilePicturePreview" alt="avatar"></v-img>
                              <v-dialog v-model="profileDialog" persistent max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <v-btn absolute fab top right color="secondary" small v-on="on">
                                    <v-icon small>fas fa-pencil-alt</v-icon>
                                  </v-btn>
                                </template>
                                <v-card>
                                  <p class="display-1 px-7 pt-5 mb-2">Imagen de perfil</p>
                                  <p class="body-2 px-7">La imagen tiene que ser cuadrada (Por ejemplo, 300x300 pixeles).</p>
                                  <v-card-text class="pb-0">
                                    <file-pond
                                      name="event-img"
                                      ref="pondProfile"
                                      label-idle="Agrega una imagen de perfil..."
                                      accepted-file-types="image/jpeg, image/png"
                                    />
                                  </v-card-text>
                                  <v-card-actions class="pt-0">
                                    <div class="flex-grow-1"></div>
                                    <v-btn color="blue darken-1" text @click="profileDialog = false">Cerrar</v-btn>
                                    <v-btn color="blue darken-1" text @click="loadProfilePicture()">Guardar</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-avatar>
                              </v-row>
                            </v-col>
                            
                            <!--<v-col cols="12">
                              <v-img :src="profilePicturePreview"></v-img>
                            </v-col>-->
                            <v-col cols="12" class="text-center">
                              <p class="title">¿Dónde será usado mi logotipo
                                <v-tooltip top max-width="350px">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="primary" dark v-on="on" style="margin-left: -5px">mdi-help-circle</v-icon>
                                </template>
                                <span>Tu logotipo ayudará a personalizar tu sección de eventos y acompañará cada boleto/acceso que reciban tus asistentes.</span>
                              </v-tooltip></p>
                            </v-col>
                            <v-col cols="12" sm="6" lg="4" class="py-1">
                              <v-text-field
                                v-model.trim="user.companyName"
                                :rules="organizerCompanyNameRules"
                                label="Nombre de usuario o empresa *"
                                required
                                prepend-icon="fas fa-city"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" lg="4" class="py-1">
                              <v-text-field
                                v-model.trim="user.name"
                                :rules="organizerNameRules"
                                label="Nombre de contacto *"
                                required
                                prepend-icon="fas fa-user"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" lg="4" class="py-1">
                              <v-text-field
                                v-model.trim="user.lastName"
                                :rules="organizerSurnamesRules"
                                label="Apellidos *"
                                required
                                prepend-icon="fas fa-user"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" lg="4" class="py-1 d-flex">
                              <v-text-field
                                class="mr-2"
                                v-model.trim="user.email"
                                :rules="organizerEmailRules"
                                label="Correo electrónico *"
                                required
                                prepend-icon="fas fa-envelope"
                              ></v-text-field>
                              <v-tooltip top max-width="350px">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                                </template>
                                <span>Este correo se usará únicamente para iniciar sesión (No se muestra en ningún otro lugar).</span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="12" sm="6" lg="4" class="py-1">
                              <v-text-field
                                v-model="user.tel"
                                :rules="organizerTelRules"
                                label="Teléfono de contacto"
                                prepend-icon="fas fa-phone"
                              ></v-text-field>
                            </v-col>
                            <!--
                            <v-col cols="12" sm="6" lg="4" class="py-1">
                              <v-text-field
                                v-model.trim="user.rfc"
                                :rules="organizerRfcRules"
                                label="RFC *"
                                required
                                prepend-icon="fas fa-id-card"
                              ></v-text-field>
                            </v-col>-->
                            <v-col cols="12" sm="6" lg="4" class="py-1">
                              <v-text-field
                                v-model.trim="user.password"
                                prepend-icon="fas fa-lock"
                                :append-icon="showPass ? 'visibility' : 'visibility_off'"
                                :rules="organizerPasswordRules"
                                :type="showPass ? 'text' : 'password'"
                                name="password"
                                label="Contraseña *"
                                hint="Debe incluir al menos 8 caracteres."
                                counter
                                @click:append="showPass = !showPass"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="py-1">
                              <v-checkbox v-model="user.terms" color="secondary" hide-details>
                                <template v-slot:label>
                                  Acepto los&nbsp;
                                  <router-link
                                    to="/terminos-y-condiciones"
                                    v-slot="{ href }"
                                  >
                                    <a
                                      :href="href"
                                      target="_blank"
                                      @click.stop
                                    >términos y condiciones.</a>
                                  </router-link>
                                </template>
                              </v-checkbox>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-window-item>
                </v-window>

                <v-divider class="mb-5 mx-5"></v-divider>

                <v-row justify="space-between" class="mx-5">
                  <v-btn color="secondary" class="mt-2" large @click="goBack()">Regresar</v-btn>
                  <v-btn
                    :disabled="((user.type==='Organizador lite')?!user.companyName:'') || !user.name || !user.lastName || !user.email || !user.password || user.terms==false || !valid"
                    color="secondary"
                    class="mt-2"
                    large
                    @click="saveUser()"
                  >Registrarme</v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <w-footer></w-footer>
  </v-container>
</template>
<script>
import { validations } from "@/helpers/validations.js";
import { imageHelper } from "@/helpers/imageProcessing.js";

import wFooter from "@/components/shared/w-footer";

import { mapMutations, mapActions, mapState } from "vuex";

// Filepond
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond/dist/filepond.min.css";
import vueFilePond from "vue-filepond";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    wFooter,
    FilePond
  },
  data() {
    return {
      fromCheckout: false,
      valid: false,
      userTypes: [
        {
          id: 1,
          name: "Asistente",
          icon: "fas fa-user-graduate",
          description:
            "¡Únete a WeChamber! Explora nuestros cursos, eventos o afiliaciones y comienza a crecer profesionalmente."
        },
        {
          id: 2,
          name: "Organizador",
          icon: "fas fa-user-tie",
          description:
            "Únete a WeChamber y publica tus eventos, cursos y talleres en cuestión de minutos."
        }
      ],
      profileDialog: false,
      valid: true,
      step: 1,
      showPass: false,

      guestCompanyNameRules: validations.generalValidation({
        required: false,
        minLength: 3,
        name: "nombre de la empresa"
      }),
      guestNameRules: validations.nameValidation({
        required: true,
        minLength: 2,
        name: "nombre del asistente"
      }),
      guestSurnamesRules: validations.surnamesValidation({
        required: true,
        minLength: 2,
        name: "apellidos del asistente"
      }),
      guestEmailRules: validations.emailValidation(),
      guestPasswordRules: validations.generalFValidation({
        required: true,
        minLength: 8,
        name: "contraseña"
      }),
      organizerCompanyNameRules: validations.generalValidation({
        required: true,
        minLength: 3,
        name: "nombre de la empresa"
      }),
      organizerNameRules: validations.nameValidation({
        required: true,
        minLength: 2,
        name: "nombre del organizador"
      }),
      organizerSurnamesRules: validations.surnamesValidation({
        required: true,
        minLength: 2,
        name: "apellidos del organizador"
      }),
      organizerEmailRules: validations.emailValidation(),
      organizerPasswordRules: validations.generalFValidation({
        required: true,
        minLength: 8,
        name: "contraseña"
      }),
      organizerTelRules: validations.phoneValidation({ required: false }),
      organizerRfcRules: validations.generalValidation({
        required: true,
        minLength: 12,
        maxLength: 13,
        name: "RFC"
      }),

      user: {
        type: "",
        companyName: "",
        name: "",
        lastName: "",
        email: "",
        tel: "",
        rfc: "",
        password: "",
        terms: false,
        profilePicture:
          "https://test-upload-files-beta-wechamber.s3.us-east-2.amazonaws.com/a4636910-9ae8-11ea-8a67-57eba99a65ad.jpg"
      },
      profilePicturePreview: "",
    };
  },
  computed: {
    ...mapState("affiliation", ["currentTier"]),
    ...mapState("plan", ["currentPlan"]),

    // MÉTODO PARA OBTENER EL TAMAÑO DE LOS ÍCONOS EN DIFERENTES VIEWPORTS
    getSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:4em";
        case "sm":
          return "font-size:4.5em";
        case "md":
          return "font-size:4.5em";
        case "lg":
          return "font-size:4.5em";
        case "xl":
          return "font-size:5.5em";
      }
    }
  },
  methods: {
    ...mapActions("user", ["createUser"]),
    ...mapMutations("notifications", ["show"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("affiliation", ["clearTier"]),

    // FUNCIÓN DE INICIALIZACIÓN DE FILEPOND (OBLIGATORIA)
    handleFilePondInit: function() {},

    // SCROLL A UNA POSICIÓN ESPECÍFICA DEL NAVEGADOR (PROGRAMATIC SCROLLING - VUETIFY)
    toTop() {
      if (this.$vuetify.breakpoint.name === "xs")
        this.$vuetify.goTo(250, { duration: 300 });
    },

    // FUNCIÓN PARA VALIDAR EL FORMULARIO
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },

    // FUNCIÓN PARA REGRESAR AL LOGIN DEL SITIO
    logIn() {
      this.$router.push("/login");
    },

    // FUNCIÓN PARA REGRESAR A LA VISTA DE INICIO DEL SITIO
    goBack() {
      this.$router.push("/");
    },

    // FUNCIÓN PARA GUARDAR UN USUARIO
    async saveUser() {
      //try {
        this.loading();
        if (this.$refs.pondProfile && this.$refs.pondProfile.getFiles().length > 0) {
          this.user.profilePicture = await imageHelper.resizeImg(
            this.$refs.pondProfile.getFiles()[0].file,
            300,
            300
          );
          let urlImg = await imageHelper.saveImage(this.user.profilePicture);
          this.user.profilePicture = urlImg;
        }
        let role = await this.createUser(this.user);
        this.loaded();
        this.$router.push("/dashboard/lite");
      //} catch (error) {
      //  console.log(error);
      //  this.loaded();
      //  this.show({
      //    text:
      //      "¡El email de usuario ya esta registrado!, Por favor ingrese uno diferente 🛑",
      //    color: "#F9A825"
      //  });
      //}
    },
    loadProfilePicture(){
      this.profilePicturePreview = URL.createObjectURL(this.$refs.pondProfile.getFiles()[0].file);
      this.profileDialog = false;
    },
  },
  mounted() {
    this.user.type = "Organizador lite";
    this.profilePicturePreview = "https://test-upload-files-beta-wechamber.s3.us-east-2.amazonaws.com/a4636910-9ae8-11ea-8a67-57eba99a65ad.jpg";
  },
};
</script>
<style scoped>
.form-img {
  background: url("../../assets/img/form-img.jpg"), no-repeat,
    rgba(29, 43, 59, 0.6);
  background-size: cover;
  min-height: 600px;
  background-blend-mode: multiply;
}
.form-container {
  min-height: 540px;
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .form-container {
    min-height: 500px;
  }
}
@media (min-width: 960px) and (max-width: 1263px) {
  .form-container {
    min-height: 565px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .form-container {
    min-height: 565px;
  }
}
</style>